import React from "react";
import { css, div } from "react-emotion";
import styled from "react-emotion";

const Container = styled("div")`
  position: relative;
  /* width: 332px; */
  display: grid;
  grid-template-columns: ${(props) => `repeat(${props.columns}, 1fr)`};
  grid-template-rows: auto;
  grid-auto-rows: 1fr;
  grid-auto-flow: row;
  min-height: 150px;
  transition: transform 0.2s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.2);
    transform: scale(1.02);
  }
`;

const Image = styled("img")`
  width: 100%;
  height: ${(props) => {
    if (props.columns === 2) {
      return "125px";
    }
    if (props.columns === 3) {
      return "100px";
    }
    return "200px";
  }};
  object-fit: cover;
  cursor: pointer;
`;

// const Image = css`
//   width: 100%;
//   height: auto;
//   object-fit: cover;
//   cursor: pointer;
// `;

const imageText = css`
  color: white;
  font-size: 11px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const imageTextContainer = css`
  width: 100%;
  position: absolute;
  bottom: 0;
  background: black;
  padding: 2px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

// TODO: dynamically set color
const Description = css`
  color: #707070;
  font-size: 9px;
  min-height: 30px;
  word-break: break-all;
`;

const ItemContainer = styled("div")`
  background: ${(props) => props.background};
  width: ${(props) => `${(332 - props.columns * 4) / props.columns}px`};
  margin: 2px;
  /* height: ${(props) => {
    if (props.columns === 3) {
      return "100px";
    }
    if (props.columns === 2) {
      return "125px";
    }
    return "200px";
  }}; */
`;

// TODO: dynamically set background later
const Circle = styled("div")`
  border-radius: 50%;
  background: white;
  margin-top: 5px;
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;
`;

const LowerItemContainer = styled("div")`
  display: flex;
  justify-content: row;
`;

const ImageContainer = styled("div")``;

const ImageItems = ({ images, columns, onClick }) => {
  // console.dir(images);
  return (
    <div>
      {/* {images.length === 0 ? "Click to add images to section." : null} */}
      <Container
        columns={images.length === 0 ? 1 : columns}
        border={images.length === 0 ? true : false}
        onClick={onClick}
      >
        {images.length === 0 ? (
          <p
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Click to add images to section.
          </p>
        ) : null}
        {images &&
          images.map((image, idx) => {
            const { url, sideTitle, title, description } = image;

            return (
              <ItemContainer
                key={idx}
                // background={image.backgroundColor}
                columns={columns}
              >
                <ImageContainer description={description}>
                  <Image
                    src={
                      url
                        ? url
                        : "https://mobile360-assets.s3.us-east-2.amazonaws.com/upload.png"
                    }
                    alt={url}
                    columns={columns}
                  />
                  <div
                    style={{
                      position: "relative",
                    }}
                  >
                    {(title || sideTitle) && (
                      <div className={imageTextContainer}>
                        <p className={imageText}>{title}</p>
                        <p className={imageText}>{sideTitle}</p>
                      </div>
                    )}
                  </div>
                </ImageContainer>
                <LowerItemContainer>
                  <p className={Description}>{description}</p>
                  {/* <Circle/> */}
                </LowerItemContainer>
              </ItemContainer>
            );
          })}
      </Container>
    </div>
  );
};

export default ImageItems;
